export enum DocumentsPermissions {
  VIEW_DOCUMENTS = "view_documents",
  CREATE_DOCUMENTS = "create_documents",
  UPDATE_DOCUMENTS = "update_documents",
  DELETE_DOCUMENTS = "delete_documents",
  APPROVE_REJECT_DOCUMENTS = "approve_reject_documents",
  DOWNLOAD_DOCUMENTS = "download_documents",
  SEND_DOCUMENTS = "send_documents",

  // Terms Sheet Documents
  VIEW_TERMS_SHEET_DOCUMENTS = "view_terms_sheet_documents",
  CREATE_TERMS_SHEET_DOCUMENTS = "create_terms_sheet_documents",
  UPDATE_TERMS_SHEET_DOCUMENTS = "update_terms_sheet_documents",
  DELETE_TERMS_SHEET_DOCUMENTS = "delete_terms_sheet_documents",
  APPROVE_REJECT_TERMS_SHEET_DOCUMENTS = "approve_reject_terms_sheet_documents",
  DOWNLOAD_TERMS_SHEET_DOCUMENTS = "download_terms_sheet_documents",
  SEND_TERMS_SHEET_DOCUMENTS = "send_terms_sheet_documents",

  // IM Documents
  VIEW_IM_DOCUMENTS = "view_im_documents",
  CREATE_IM_DOCUMENTS = "create_im_documents",
  UPDATE_IM_DOCUMENTS = "update_im_documents",
  DELETE_IM_DOCUMENTS = "delete_im_documents",
  APPROVE_REJECT_IM_DOCUMENTS = "approve_reject_im_documents",
  DOWNLOAD_IM_DOCUMENTS = "download_im_documents",
  SEND_IM_DOCUMENTS = "send_im_documents",

  // My Drive Documents
  VIEW_MY_DRIVE_DOCUMENTS = "view_my_drive",
  CREATE_MY_DRIVE_DOCUMENTS = "create_my_drive",
  UPDATE_MY_DRIVE_DOCUMENTS = "update_my_drive",
  DELETE_MY_DRIVE_DOCUMENTS = "delete_my_drive",
  DOWNLOAD_MY_DRIVE_DOCUMENTS = "download_my_drive",
  SEND_MY_DRIVE_DOCUMENTS = "send_my_drive",

  // Documents to be approved
  VIEW_DOCUMENTS_TO_BE_APPROVED = "view_documents_to_be_approved",
  UPDATE_DOCUMENTS_TO_BE_APPROVED = "update_documents_to_be_approved",
  APPROVE_REJECT_DOCUMENTS_TO_BE_APPROVED = "approve_reject_documents_to_be_approved",
  DOWNLOAD_DOCUMENTS_TO_BE_APPROVED = "download_documents_to_be_approved",
  SEND_DOCUMENTS_TO_BE_APPROVED = "send_documents_to_be_approved",

  // Documents to be signed
  VIEW_DOCUMENTS_TO_BE_SIGNED = "view_documents_to_be_signed",
  UPDATE_DOCUMENTS_TO_BE_SIGNED = "update_documents_to_be_signed",
  APPROVE_REJECT_DOCUMENTS_TO_BE_SIGNED = "approve_reject_documents_to_be_signed",
  DOWNLOAD_DOCUMENTS_TO_BE_SIGNED = "download_documents_to_be_signed",
  SEND_DOCUMENTS_TO_BE_SIGNED = "send_documents_to_be_signed",
}

export const DocumentsPermissionsText: Record<DocumentsPermissions, string> = {
  [DocumentsPermissions.VIEW_DOCUMENTS]: "View Documents",
  [DocumentsPermissions.CREATE_DOCUMENTS]: "Create Documents",
  [DocumentsPermissions.UPDATE_DOCUMENTS]: "Update Documents",
  [DocumentsPermissions.DELETE_DOCUMENTS]: "Delete Documents",
  [DocumentsPermissions.APPROVE_REJECT_DOCUMENTS]: "Approve/Reject Documents",
  [DocumentsPermissions.DOWNLOAD_DOCUMENTS]: "Download Documents",
  [DocumentsPermissions.SEND_DOCUMENTS]: "Send Documents",
  [DocumentsPermissions.VIEW_TERMS_SHEET_DOCUMENTS]:
    "View Terms Sheet Documents",
  [DocumentsPermissions.CREATE_TERMS_SHEET_DOCUMENTS]:
    "Create Terms Sheet Documents",
  [DocumentsPermissions.UPDATE_TERMS_SHEET_DOCUMENTS]:
    "Update Terms Sheet Documents",
  [DocumentsPermissions.DELETE_TERMS_SHEET_DOCUMENTS]:
    "Delete Terms Sheet Documents",
  [DocumentsPermissions.APPROVE_REJECT_TERMS_SHEET_DOCUMENTS]:
    "Approve/Reject Terms Sheet Documents",
  [DocumentsPermissions.DOWNLOAD_TERMS_SHEET_DOCUMENTS]:
    "Download Terms Sheet Documents",
  [DocumentsPermissions.SEND_TERMS_SHEET_DOCUMENTS]:
    "Send Terms Sheet Documents",
  [DocumentsPermissions.VIEW_IM_DOCUMENTS]: "View IM Documents",
  [DocumentsPermissions.CREATE_IM_DOCUMENTS]: "Create IM Documents",
  [DocumentsPermissions.UPDATE_IM_DOCUMENTS]: "Update IM Documents",
  [DocumentsPermissions.DELETE_IM_DOCUMENTS]: "Delete IM Documents",
  [DocumentsPermissions.APPROVE_REJECT_IM_DOCUMENTS]:
    "Approve/Reject IM Documents",
  [DocumentsPermissions.DOWNLOAD_IM_DOCUMENTS]: "Download IM Documents",
  [DocumentsPermissions.SEND_IM_DOCUMENTS]: "Send IM Documents",
  [DocumentsPermissions.VIEW_MY_DRIVE_DOCUMENTS]: "View My Drive Documents",
  [DocumentsPermissions.CREATE_MY_DRIVE_DOCUMENTS]: "Create My Drive Documents",
  [DocumentsPermissions.UPDATE_MY_DRIVE_DOCUMENTS]: "Update My Drive Documents",
  [DocumentsPermissions.DELETE_MY_DRIVE_DOCUMENTS]: "Delete My Drive Documents",
  [DocumentsPermissions.DOWNLOAD_MY_DRIVE_DOCUMENTS]:
    "Download My Drive Documents",
  [DocumentsPermissions.SEND_MY_DRIVE_DOCUMENTS]: "Send My Drive Documents",
  [DocumentsPermissions.VIEW_DOCUMENTS_TO_BE_APPROVED]:
    "View Documents to be Approved",
  [DocumentsPermissions.UPDATE_DOCUMENTS_TO_BE_APPROVED]:
    "Update Documents to be Approved",
  [DocumentsPermissions.APPROVE_REJECT_DOCUMENTS_TO_BE_APPROVED]:
    "Approve/Reject Documents to be Approved",
  [DocumentsPermissions.DOWNLOAD_DOCUMENTS_TO_BE_APPROVED]:
    "Download Documents to be Approved",
  [DocumentsPermissions.SEND_DOCUMENTS_TO_BE_APPROVED]:
    "Send Documents to be Approved",
  [DocumentsPermissions.VIEW_DOCUMENTS_TO_BE_SIGNED]:
    "View Documents to be Signed",
  [DocumentsPermissions.UPDATE_DOCUMENTS_TO_BE_SIGNED]:
    "Update Documents to be Signed",
  [DocumentsPermissions.APPROVE_REJECT_DOCUMENTS_TO_BE_SIGNED]:
    "Approve/Reject Documents to be Signed",
  [DocumentsPermissions.DOWNLOAD_DOCUMENTS_TO_BE_SIGNED]:
    "Download Documents to be Signed",
  [DocumentsPermissions.SEND_DOCUMENTS_TO_BE_SIGNED]:
    "Send Documents to be Signed",
};
